<script lang="ts">
    import { clickEnter } from "@utils/directives/accessibility"
    import { resetPassword } from "@utils/underhood/firebase"
    let resetting: ReturnType<typeof resetPassword>
    export let email: string
    let emailed = ""
    let disabled = false

    function reset() {
        disabled = true
        emailed = email
        resetting = resetPassword(email)
        resetting.catch((e) => {
            disabled = false
            console.error(e.code)
        })
    }

    $: resetting
</script>

<p class="reset-password">
    <span
        class="link underline"
        role="link"
        tabindex={0}
        on:keydown={clickEnter}
        class:disabled
        on:click={reset}>I forgot my password</span
    >.
    {#if resetting}
        <!-- svelte-ignore empty-block -->
        {#await resetting then _}
            <br />A password reset email has been sent to {emailed}
        {:catch err}
            <error
                >Oops! {err
                    ? err.code
                        ? err.code == "auth/user-not-found"
                            ? "Account not found."
                            : "Something went wrong."
                        : err
                    : "Something went wrong."}</error
            >
        {/await}
    {/if}
</p>

<style>
    .reset-password {
        margin-top: 0.5em;
        color: var(--color-grey-600);
        font-size: 0.95rem;
        line-height: 1.5;
    }

    error {
        display: block;
        color: var(--danger);
    }

    :global(.darkmode) .reset-password {
        color: var(--color-grey-200);
    }
</style>
